import type { IComponentController, IScope } from "angular";
import "angular-translate";
import { filter as lodashFilter } from "lodash";
import { finalize } from "rxjs/operators";

import type { IResponseWithLoading, ISiteEquipmentSlim } from "App/Modules/Models";
import { EquipmentClass } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class HardwareComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "$translate", "mmSitesRepository"];

    public caption: string;

    public siteEquipment: IResponseWithLoading<ISiteEquipmentSlim[]>;

    public siteId: string;

    public subCaption: string;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        this.caption = "Entities.SiteEquipment.Hardware";
        this.subCaption = null;

        extendWithLoadingAndFail(this.sitesRepository.getSiteEquipmentsForSite(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result) => {
                    this.siteEquipment = result;
                    if (!this.siteEquipment.data) {
                        return;
                    }
                    const cameraCount = lodashFilter(
                        this.siteEquipment.data,
                        (se) => se.class === EquipmentClass.Camera,
                    ).length;
                    const otherEquipmentCount = this.siteEquipment.data.length - cameraCount;

                    this.$translate(
                        [
                            "Entities.SiteEquipment.CamerasCountFormat",
                            "Entities.SiteEquipment.OtherHardwareCountFormat",
                        ],
                        { cameraCount, otherCount: otherEquipmentCount },
                        "messageformat",
                    ).then((translations) => {
                        this.caption = translations["Entities.SiteEquipment.CamerasCountFormat"];
                        this.subCaption = translations["Entities.SiteEquipment.OtherHardwareCountFormat"];
                    });
                },
                (result) => {
                    this.siteEquipment = result;
                },
            );
    }
}
